module.exports = __webpack_public_path__ + "img/id.ddd51099.png";